import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation, NgModule } from '@angular/core';
import * as i1 from '@play/api-client';
import { TournamentApiModule, PremiumApiModule } from '@play/api-client';
import { getUser, distinct, StateModule } from '@play/state';
import * as i2 from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { filter, map, switchMap, first } from 'rxjs/operators';
import * as i3 from '@play/common';
import { InheritClassComponent, CommonsComponentModule } from '@play/common';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@play/translate';
import { TranslationModule } from '@play/translate';

class PremiumButtonComponent extends InheritClassComponent {
    constructor(resource, store) {
        super();
        this.resource = resource;
        this.store = store;
        this.loading$ = new BehaviorSubject(true);
    }
    ngOnInit() {
        this.isLoggedIn$ = this.store.select(getUser).pipe(filter(user => user && Boolean(!user.loading || user.entry)), distinct(user => Boolean(user.entry)));
        this.title$ = this.isLoggedIn$.pipe(map(loggedIn => (loggedIn ? "premium-button:get-premium" : "premium-button:login")));
        this.currentUrl = window.location.href;
        const head = document.getElementsByTagName("head")[0];
        if (!head.querySelector("#paystation-script")) {
            const xsollaScript = document.createElement("script");
            xsollaScript.type = "text/javascript";
            xsollaScript.id = "paystation-script";
            xsollaScript.async = true;
            xsollaScript.src = "https://static.xsolla.com/embed/paystation/1.0.7/widget.min.js";
            xsollaScript.addEventListener("load", e => {
                this.isLoggedIn$
                    .pipe(filter(Boolean), switchMap(() => this.resource.getAccessToken(this.currentUrl)), first())
                    .subscribe(accesToken => {
                    const options = {
                        access_token: accesToken,
                        sandbox: false,
                    };
                    XPayStationWidget.init(options);
                    this.loading$.next(false);
                });
            }, false);
            head.appendChild(xsollaScript);
        }
        else {
            this.loading$.next(false);
        }
    }
}
PremiumButtonComponent.ɵfac = function PremiumButtonComponent_Factory(t) { return new (t || PremiumButtonComponent)(i0.ɵɵdirectiveInject(i1.PremiumResource), i0.ɵɵdirectiveInject(i2.Store)); };
PremiumButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PremiumButtonComponent, selectors: [["premium-button"]], inputs: { titleKey: "titleKey", childrenClasses: "childrenClasses" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 15, consts: [["data-xpaystation-widget-open", "", 3, "disabled", "title"]], template: function PremiumButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "play-button", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵpipe(4, "async");
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.childrenClasses || ctx.classList);
        i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind1(1, 5, ctx.isLoggedIn$) || i0.ɵɵpipeBind1(2, 7, ctx.loading$))("title", i0.ɵɵpipeBind1(3, 9, ctx.titleKey ? ctx.titleKey : i0.ɵɵpipeBind1(4, 11, ctx.title$) || "premium-button:get-premium"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 13, ctx.titleKey || "premium-button:get-premium"));
    } }, directives: [i3.ButtonComponent], pipes: [i4.AsyncPipe, i5.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiumButtonComponent, [{
        type: Component,
        args: [{
                selector: "premium-button",
                templateUrl: "./premium-button.component.html",
                styleUrls: ["./premium-button.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.PremiumResource }, { type: i2.Store }]; }, { titleKey: [{
            type: Input
        }], childrenClasses: [{
            type: Input
        }] }); })();

const premiumButtonTexts = {
    "premium-button:get-premium": "Get Premium",
    "premium-button:login": "You need to be logged in to get premium",
};

class PremiumBadgeComponent {
}
PremiumBadgeComponent.ɵfac = function PremiumBadgeComponent_Factory(t) { return new (t || PremiumBadgeComponent)(); };
PremiumBadgeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PremiumBadgeComponent, selectors: [["premium-badge"]], decls: 4, vars: 1, consts: [[1, "premium-badge"], ["href", "/premium", 3, "tooltip"], ["width", "12", "height", "9", "viewBox", "0 0 12 9", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 0H8.14362C9.47065 0 10.4139 0.285367 10.9695 0.8561C11.2216 1.10558 11.4049 1.41829 11.5214 1.79593C11.6206 2.13256 11.6703 2.5307 11.6703 2.98866V3.7354C11.6703 4.08911 11.6245 4.41891 11.5366 4.72307C11.4373 5.06824 11.2903 5.36557 11.0917 5.61506C10.6163 6.22509 9.89454 6.53096 8.92456 6.53096H2.98822V8.72333H0V0ZM2.98822 4.36081H7.6319C8.27727 4.36081 8.60187 4.05152 8.60187 3.43294V3.09631C8.60187 2.47773 8.19326 2.16844 7.37794 2.16844H2.99013V4.36081H2.98822Z", "fill", "#FF7300"]], template: function PremiumBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "a", 1);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(2, "svg", 2);
        i0.ɵɵelement(3, "path", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tooltip", "ESL Premium");
    } }, directives: [i3.TooltipDirective], styles: ["[_nghost-%COMP%]{position:relative}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiumBadgeComponent, [{
        type: Component,
        args: [{
                selector: "premium-badge",
                templateUrl: "./premium-badge.component.html",
                styleUrls: ["./premium-badge.component.scss"],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

class PremiumOfferComponent {
    constructor(resource, store) {
        this.resource = resource;
        this.store = store;
    }
    ngOnInit() {
        this.isLoggedIn$ = this.store.select(getUser).pipe(filter(user => user && Boolean(!user.loading || user.entry)), distinct(user => Boolean(user.entry)));
        this.currentUrl = window.location.href;
        const head = document.getElementsByTagName("head")[0];
        const xsollaScript = document.createElement("script");
        xsollaScript.type = "text/javascript";
        xsollaScript.async = true;
        xsollaScript.src = "https://static.xsolla.com/embed/pay2play/2.2.2/widget.min.js";
        xsollaScript.addEventListener("load", () => {
            this.isLoggedIn$
                .pipe(filter(Boolean), switchMap(() => this.resource.getAccessToken(this.currentUrl, this.digitalContent)), first())
                .subscribe(accesToken => {
                const options = {
                    access_token: accesToken,
                    sandbox: false,
                    theme: {
                        foreground: "green",
                        background: "light",
                    },
                    lightbox: {
                        height: "700px",
                        spinner: "round",
                    },
                    target_element: `#${this.digitalContent}`,
                };
                XPay2PlayWidget.create(options);
            });
        }, false);
        head.appendChild(xsollaScript);
    }
}
PremiumOfferComponent.ɵfac = function PremiumOfferComponent_Factory(t) { return new (t || PremiumOfferComponent)(i0.ɵɵdirectiveInject(i1.PremiumResource), i0.ɵɵdirectiveInject(i2.Store)); };
PremiumOfferComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PremiumOfferComponent, selectors: [["premium-offer"]], inputs: { digitalContent: "digitalContent" }, decls: 1, vars: 1, consts: [[3, "id"]], template: function PremiumOfferComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("id", ctx.digitalContent);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiumOfferComponent, [{
        type: Component,
        args: [{
                selector: "premium-offer",
                templateUrl: "./premium-offer.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.PremiumResource }, { type: i2.Store }]; }, { digitalContent: [{
            type: Input
        }] }); })();

class PremiumModule {
}
PremiumModule.ɵfac = function PremiumModule_Factory(t) { return new (t || PremiumModule)(); };
PremiumModule.ɵmod = i0.ɵɵdefineNgModule({ type: PremiumModule });
PremiumModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TournamentApiModule, PremiumApiModule, StateModule, CommonsComponentModule, TranslationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PremiumModule, { declarations: [PremiumButtonComponent, PremiumBadgeComponent, PremiumOfferComponent], imports: [CommonModule, TournamentApiModule, PremiumApiModule, StateModule, CommonsComponentModule, TranslationModule], exports: [PremiumButtonComponent, PremiumBadgeComponent, PremiumOfferComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiumModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TournamentApiModule, PremiumApiModule, StateModule, CommonsComponentModule, TranslationModule],
                declarations: [PremiumButtonComponent, PremiumBadgeComponent, PremiumOfferComponent],
                exports: [PremiumButtonComponent, PremiumBadgeComponent, PremiumOfferComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of premium
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PremiumBadgeComponent, PremiumButtonComponent, PremiumModule, PremiumOfferComponent, premiumButtonTexts };
//# sourceMappingURL=play-premium.js.map
